/*

THIS IS THE COMPONENT THAT WILL BE USED TO RENDER THE STEPPER for the checkout 


*/

import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import './Stepper.css';
import clsx from 'clsx';
import Check from '@material-ui/icons/Check';
import PropTypes from 'prop-types';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import StepConnector from '@material-ui/core/StepConnector';


//Redux
import { useSelector } from 'react-redux';

const QontoConnector = withStyles(({ palette, spacing }) => ({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: palette.primary.main,
    },
  },
  completed: {
    '& $line': {
      borderColor: palette.primary.main,
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}))(StepConnector);


const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    // justifyContent: 'center',
  },
  active: props => ({
    color: props.color,
  }),
  circle: {
    display: 'flex',
    width: 25,
    height: 25,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
    justifyContent: 'center',
    alignItems: 'center',

    //marginLeft: '-15%'


  },
  completed: props => ({
    color: props.color,
    zIndex: 1,
    fontSize: 25,
  }),
  font: {
    fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
    textAlign: 'center',
    fontSize: '0.7rem',
    marginLeft: '-3%',
  }
});

const QontoStepIcon = (props) => {
  const primary = useSelector(state => state.frontConfigReducer.color);
  const classes = useQontoStepIconStyles({ color: primary });
  const { active, completed } = props;

  useEffect(() => {

  }, [props.active, props.completed])

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle}> <p style={{ color: active ? 'white' : 'rgb(83, 81, 81)' }} className={classes.font}>{props.icon}</p> </div>}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '90%',
    marginBottom: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    "& .MuiTypography-body2": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontSize: '0.9rem',
    },
    "& .MuiStepLabel-label.MuiStepLabel-active": {
      fontWeight: 'bold',
    }
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ['Cart', 'Customer', 'Shipping', 'Payment'];
}

function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
      return 'Cart';
    case 1:
      return
    case 2:
      return 'Insert Shipping Method Componet here';
    case 3:
      return 'Insert Payment Method Component here';
    default:
      return 'Unknown stepIndex';
  }
}

const stepperRoot = { padding: '0', marginRight: '0', width: '100%', backgroundColor: 'transparent' };


export default function CheckoutStepper() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const matches = useMediaQuery("(max-width:599px)");

  const navigationStep = useSelector(state => state.navigationReducer.checkoutStep);
  const { t, i18n } = useTranslation();

  const handleReset = () => {
    setActiveStep(0);
  };

  useEffect(() => {
  }, [navigationStep])

  return (
    <div className={classes.root} style={{paddingTop: matches ? '10px' : '0px'}}>
      <Stepper style={stepperRoot} connector={matches ? <QontoConnector /> : null} activeStep={navigationStep} alternativeLabel={matches ? true : false}>
      {/* <Stepper style={stepperRoot} connector={matches ? <QontoConnector /> : null} activeStep={navigationStep}> */}
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel style={{ marginLeft: matches ? "-20%" : "-5%" }} StepIconComponent={QontoStepIcon}>{t(label)}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>

  );
}



